import { render, staticRenderFns } from "./add_role.vue?vue&type=template&id=1b260b8e&scoped=true&"
import script from "./add_role.vue?vue&type=script&lang=js&"
export * from "./add_role.vue?vue&type=script&lang=js&"
import style0 from "./add_role.vue?vue&type=style&index=0&id=1b260b8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b260b8e",
  null
  
)

export default component.exports